import styled from 'styled-components';

const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
`;

export { MainLayout, Container };
